var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPotd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2234.000000pt",
    height: "2048.000000pt",
    viewBox: "0 0 2234.000000 2048.000000",
    fill: "yellow",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,2048.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9888 16558 l -1275 -3783 l -3983 -5 l -3983 -5 l 3186 -2390 c 1753 -1314 3187 -2395 3187 -2401 c 0 -6 -513 -1707 -1139 -3779 c -627 -2073 -1138 -3771 -1137 -3773 c 2 -1 1446 1005 3210 2238 c 1764 1232 3211 2240 3216 2240 c 5 0 1453 -1008 3216 -2240 c 1764 -1233 3208 -2239 3210 -2238 c 1 2 -510 1700 -1137 3773 c -626 2073 -1139 3773 -1139 3779 c 0 6 1434 1087 3187 2401 l 3186 2390 l -3983 5 l -3983 5 l -1275 3783 c -702 2080 -1278 3782 -1282 3782 c -4 0 -580 -1702 -1282 -3782 z z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotd);
export default __webpack_public_path__ + "static/media/POTD.f8ccbf09180a5db58f2c2101d6fc4630.svg";
export { ForwardRef as ReactComponent };